import React from "react";

import ContactForm from "./ContactForm"

const InvoiceContactForm = (props) => {
  return <ContactForm type="invoice" tradeDocId={props.match.params.id} />
}

export default InvoiceContactForm;




// WEBPACK FOOTER //
// ./src/features/trade_documents/containers/InvoiceContactForm.js